import { Suspense } from 'react';
import { DefaultErrorBoundary } from '@trukt/ui/DefaultErrorBoundary';
import { Loading } from '@trukt/ui/Loading';
import { useRoutes } from './hooks';

const Pages = () => {
  const routes = useRoutes();

  return (
    <Suspense fallback={<Loading fullscreen />}>
      <DefaultErrorBoundary>{routes}</DefaultErrorBoundary>
    </Suspense>
  );
};

export default Pages;
